import { Card, Divider, Box } from "@mui/material";
import { CardFormFragmentTransition } from "helpers/transitions";
import { useCallback, useState } from "react";
import { TransitionStatus } from "react-transition-group";
import theme from "theme";

interface PinFormProps {
  mode: "drawer" | "panel";
  intakeViewerRef?: HTMLElement;
  state?: TransitionStatus;
  pinMode: boolean;
  children: React.ReactNode;
}

const PinForm = (props: PinFormProps) => {
  const { mode, intakeViewerRef, state, pinMode, children } = props;
  const [panelRef, setPanelRef] = useState<HTMLElement | null>(null);
  const panelRefSet = useCallback((ref: HTMLElement) => {
    setPanelRef(ref);
  }, []);

  const intakeViewerTopOnScreen = intakeViewerRef && intakeViewerRef?.getBoundingClientRect().top > 0;

  return mode === "panel" && intakeViewerRef !== undefined ? (
    <>
      <Box
        ref={panelRefSet}
        sx={{
          zIndex: theme.zIndex.drawer,
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.7,
          background: theme.palette.grey[50],
        }}
      />
      {panelRef !== null && (
        <Card
          variant="outlined"
          sx={{
            position: "fixed",
            top: intakeViewerTopOnScreen ? intakeViewerRef.getBoundingClientRect().top : 16,
            left: 16,
            right: intakeViewerRef.getBoundingClientRect().width + 32,
            zIndex: theme.zIndex.modal,
            maxHeight: `${
              intakeViewerTopOnScreen
                ? panelRef.clientHeight - intakeViewerRef.getBoundingClientRect().top - 16
                : panelRef.clientHeight - 32
            }px`,
            overflowY: "auto",
          }}>
          {children}
        </Card>
      )}
    </>
  ) : state !== undefined ? (
    <Box
      data-pendo={pinMode ? "document-viewer-pin-form" : ""}
      sx={{
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
      style={{
        height: 0,
        transition: `height 300ms ease-in-out, min-height 300ms ease-in-out`,
        ...CardFormFragmentTransition[state],
      }}>
      {(state === "entering" || state === "entered") && children}
      <Divider />
    </Box>
  ) : (
    <></>
  );
};

export default PinForm;
